<template>
  <div class="p-col-12">
    <Panel header="" style="height: 100%">
      <Fieldset legend="Dados do Paciente" class="mb-3">
        <div class="p-fluid formgrid grid">
          <div class="field col-12 md:col-4">
            <label for="nome">Nome do Paciente</label>
            <InputText id="nome" disabled />
          </div>
          <div class="field col-12 md:col-4">
            <label for="nome">CPF</label>
            <InputText id="nome" disabled />
          </div>
          <div class="field col-12 md:col-4">
            <label for="nome">CNS</label>
            <InputText id="nome" disabled />
          </div>
          <div class="field col-12 md:col-4">
            <label for="capacity">Nome da Mãe</label>
            <InputText disabled />
          </div>

          <div class="field col-12 md:col-4">
            <label for="capacity">Nascimento</label>
            <InputText disabled />
          </div>
          <div class="field col-12 md:col-2">
            <label for="capacity">Raça</label>
            <InputText disabled />
          </div>
          <div class="field col-12 md:col-2">
            <label for="capacity">Sexo</label>
            <InputText disabled />
          </div>
        </div>

        <div class="flex justify-content-end flex-wrap"></div>
      </Fieldset>

      <DataTable
        :value="data"
        :paginator="true"
        :rows="10"
        :rowsPerPageOptions="[10, 20, 30]"
        ref="dt"
        class="p-datatable-sm"
        dataKey="id"
        :loading="loading"
        :rowClass="rowClass"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Exibindo de {first} a {last} no total de {totalRecords} registros."
      >
        <template #empty>
          <div class="text-center">Nenhum resultado encontrado...</div>
        </template>
        
        <!--
        <Column field="paciente.nome" header="Paciente">
          <template #body="slotProps">
            {{ slotProps.data.paciente.nome.toUpperCase() }}
          </template>
        </Column>
        <Column field="paciente.cpf" header="CPF">
          <template #body="slotProps">
            {{
              slotProps.data.paciente.cpf ? slotProps.data.paciente.cpf : "-"
            }}
          </template>
        </Column>
        <Column field="paciente.nomeMae" header="Nome da Mãe">
          <template #body="slotProps">
            {{ slotProps.data.paciente.nomeMae.toUpperCase() }}
          </template>
        </Column>

        <Column field="paciente.nascimento" header="Nascimento">
          <template #body="slotProps">
            {{ $DateTime.formatarDate(slotProps.data.paciente.nascimento) }}
          </template>
        </Column>
        -->

        <Column field="solicitacaoId" header="N° Solicitação">
          <template #body="slotProps">
            {{ slotProps.data.solicitacaoId }}
          </template>
        </Column>

        <Column field="data" header="Data">
          <template #body="slotProps"
            >{{ $DateTime.formatarDate(slotProps.data.data) }}
          </template>
        </Column>

        <Column field="tipo" header="Tipo">
          <template #body="slotProps">
            <b>{{ slotProps.data.tipo.toUpperCase() }}</b>
          </template>
        </Column>

        <Column field="estado" header="Situação">
          <template #body="slotProps"
            ><b> {{ slotProps.data.estado }}</b>
          </template>
        </Column>

        <Column field="centralRegulacaoResponsavel" header="Local/Unidade">
          <template #body="slotProps">
            <b>{{
              slotProps.data.centralRegulacaoResponsavel.descricao.toUpperCase()
            }}</b>
          </template>
        </Column>

        <Column field="especialidade" header="Especialidade">
          <template #body="slotProps">
            <b>{{
              slotProps.data.especialidade
                ? slotProps.data.especialidade.value.toUpperCase()
                : "-"
            }}</b>
          </template>
        </Column>

        <Column field="caraterInternacao" header="Carater">
          <template #body="slotProps">
            <b>{{
              slotProps.data.caraterInternacao
                ? slotProps.data.caraterInternacao.toUpperCase()
                : "-"
            }}</b>
          </template>
        </Column>

        <Column field="codigoProcedimento" header="Cod. Procedimento">
          <template #body="slotProps">
            <b>{{
              slotProps.data.codigoProcedimento
                ? slotProps.data.codigoProcedimento.toUpperCase()
                : "-"
            }}</b>
          </template>
        </Column>
      </DataTable>
    </Panel>
  </div>
  <ConfirmDialog></ConfirmDialog>
</template>

<script>
//Models

//Services

//Components

export default {
  components: {},
  data() {
    return {
      data: [
        {
          nrProcesso: "5121090-83.7448.8.14.1458",
          solicitacaoId: 3655312,
          paciente: {
            idMitra: null,
            idCadSUS: null,
            idCM: null,
            nome: "ANTONIO NORBERTO ALVES TRINDADE",
            nomeMae: "maria alves trindade",
            nomePai: null,
            cnsList: [],
            cpf: "364.004.912-87",
            racaPaciente: "PARDA",
            nascimento: "1949-06-05",
            sexo: "M",
            pacienteId: null,
            cnesUnidade: null,
            logradouro: "rua primavera",
            codigoTipoLogradouro: null,
            bairro: "são francisco",
            numero: null,
            complemento: null,
            cep: "67200",
            codigoIBGEMunicipio: "1504422",
            nomeMunicipio: "MARITUBA",
            ufEstado: null,
            telefone: null,
            telefoneCelular: null,
            codigoPaisOrigem: null,
            codigoIBGEMunicipioOrigem: null,
          },
          numeroCNSPaciente: "702409023072224",
          data: "2021-06-09",
          estado: "EM_FILA",
          tipo: "Consulta",
          centralRegulacaoResponsavel: {
            id: 114,
            descricao: "CENTRAL ESTADUAL REGULAÇÃO (CER)",
            tipo: null,
            codigoExterno: null,
            codigoIbgeMunicipio: null,
            aliasProvedorIntegracao: null,
          },
          justificativa: null,
          especialidade: null,
          caraterInternacao: null,
          codigoProcedimento: null,
          tipoDeLeito: null,
          idServicoRede: 1644,
          aliasProvedor: "SER2_PARA_HML",
        },
        {
          nrProcesso: "2020",
          solicitacaoId: 3650035,
          paciente: {
            idMitra: null,
            idCadSUS: null,
            idCM: null,
            nome: "ALINE CARLA DOS REIS GUIMARAES",
            nomeMae: "ANTONIA DOS REIS GUIMARAES",
            nomePai: null,
            cnsList: [],
            cpf: "887.247.862-68",
            racaPaciente: "INDIGENA",
            nascimento: "1986-05-19",
            sexo: "F",
            pacienteId: null,
            cnesUnidade: null,
            logradouro: "RUA ANTONIO ALVES",
            codigoTipoLogradouro: null,
            bairro: "APEU",
            numero: null,
            complemento: null,
            cep: "68745",
            codigoIBGEMunicipio: "1502400",
            nomeMunicipio: "CASTANHAL",
            ufEstado: null,
            telefone: null,
            telefoneCelular: null,
            codigoPaisOrigem: null,
            codigoIBGEMunicipioOrigem: null,
          },
          numeroCNSPaciente: "700003676428506",
          data: "2020-12-09",
          estado: "AGENDADA",
          tipo: "Exame",
          centralRegulacaoResponsavel: {
            id: 114,
            descricao: "CENTRAL ESTADUAL REGULAÇÃO (CER)",
            tipo: null,
            codigoExterno: null,
            codigoIbgeMunicipio: null,
            aliasProvedorIntegracao: null,
          },
          justificativa: null,
          especialidade: null,
          caraterInternacao: null,
          codigoProcedimento: null,
          tipoDeLeito: null,
          idServicoRede: 2338,
          aliasProvedor: "SER2_PARA_HML",
        },
        {
          nrProcesso: "08023633920208140040",
          solicitacaoId: 3473317,
          paciente: {
            idMitra: null,
            idCadSUS: null,
            idCM: null,
            nome: "ANGELO DAVID DE BESSA GOMES",
            nomeMae: "FLAVIA TEREZA DE BESSA GOMES ",
            nomePai: null,
            cnsList: [],
            cpf: null,
            racaPaciente: null,
            nascimento: "2014-04-15",
            sexo: "M",
            pacienteId: null,
            cnesUnidade: null,
            logradouro: "RUA 61",
            codigoTipoLogradouro: null,
            bairro: "NOVA CARAJAS ",
            numero: null,
            complemento: null,
            cep: "68515-000",
            codigoIBGEMunicipio: "1505536",
            nomeMunicipio: "PARAUAPEBAS",
            ufEstado: null,
            telefone: null,
            telefoneCelular: null,
            codigoPaisOrigem: null,
            codigoIBGEMunicipioOrigem: null,
          },
          numeroCNSPaciente: "898005163496311",
          data: "2020-03-16",
          estado: "ALTA",
          tipo: "Internação",
          centralRegulacaoResponsavel: {
            id: 107,
            descricao: "CRR MARABA",
            tipo: null,
            codigoExterno: null,
            codigoIbgeMunicipio: null,
            aliasProvedorIntegracao: null,
          },
          justificativa: null,
          especialidade: {
            key: 17,
            value: "PNEUMOLOGIA",
          },
          caraterInternacao: "URGENCIA",
          codigoProcedimento: "0303140151",
          tipoDeLeito: {
            key: 32,
            value: "UTI Pediátrico",
            id: 32,
            descricao: "UTI Pediátrico",
          },
          idServicoRede: null,
          aliasProvedor: "SER2_PARA_HML",
        },
      ],
    };
  },
  mounted() {},
  methods: {},
};
</script>
